import {useState, useEffect,useReducer} from 'react'
// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from 'components/MDButton';

// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import DefaultProjectCard from "examples/Cards/ProjectCards/DefaultProjectCard";


import {getPhotoSource} from "api/requests"
import {readStream} from "readStream/readStream"

import { getProducts } from "api/products/getProducts";
import { useTokenContext } from "App";

import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import AddIcon from '@mui/icons-material/Add';
import GetAppIcon from '@mui/icons-material/GetApp';

function RetailerProducts() {
  const [products, setProducts] = useState(null);
  const [myStorage, setMyStorage] = useState([])
  const [nrPhotosDownloaded, setNrPhotosDownloaded] = useState(0)
  const {token} = useTokenContext();

  useEffect(() => {
    if(products){
        for(var i=0; i < products["data"]["products"].length; i++){
          const shopLogoId = products["data"]["products"][i]["shop"]["logo_id"]
          const productPhotoId = products["data"]["products"][i]["product"]["product_photos_ids"][0]
          if(localStorage.getItem(shopLogoId) === null){
            getPhotoSource(shopLogoId, token)
            .then(response => {
              const reader = response.body.getReader();
              readStream(reader)
              .then(base64Response => {
                localStorage.setItem(shopLogoId, base64Response)
                setNrPhotosDownloaded(nr => nr+1)
              })
              
            })
          }
          if(localStorage.getItem(productPhotoId) === null){
            getPhotoSource(productPhotoId, token)
            .then(response => {
              const reader = response.body.getReader();
              readStream(reader)
              .then(base64Response => {
                localStorage.setItem(productPhotoId, base64Response)
                setNrPhotosDownloaded(nr => nr+1)
              })
            })
          }
        }
      }
  }, [products, token]);

  const doGetProducts = async () => {
    try{
      let productsPromise = await getProducts(token);
      setProducts(productsPromise);

    } catch (error) {
      console.error("Error on get products: ", error)
    }
  }

  useEffect(() => {
    doGetProducts();
  }, []);


  useEffect(() => {
    setMyStorage(localStorage)
  }, [nrPhotosDownloaded])

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Card>
        <MDBox mb={2} />
          <MDBox p={2}>
            <Grid container spacing={6}>
              <Grid item xs={12} md={12} xl={12}>
                <MDButton variant="gradient" color="dark" sx={{marginRight:"1rem"}}>
                  <AddIcon />&nbsp;
                  Add new product
                </MDButton>
                <MDButton variant="gradient" color="dark" sx={{marginRight:"1rem"}} >
                  <ArrowDownwardIcon />&nbsp;
                  Import products from csv
                </MDButton>
                <MDButton variant="gradient" color="dark">
                  <GetAppIcon />&nbsp;
                  get product from URL
                </MDButton>
              </Grid>
                {products && products['data']['products'].map((product, index) => (
                    <Grid item xs={12} md={6} xl={3} key={product["product"]["id"] + index}>
                      {product["product"]["product_photos_ids"][0] in myStorage &&
                        <DefaultProjectCard
                        image={'data:image/png;base64,' + myStorage[product["product"]["product_photos_ids"][0]]}
                        label={product["product"]["product_category"]}
                        title={product["product"]["product_name"]}
                        description={product["product"]["product_description"]}
                        customFields={[product["product"]['product_code'], "Stock: " + product['product']['product_stock'], "Price: " + (product['product']['product_price']/100).toFixed(2) + " $"]}
                        action={{
                          type: "internal",
                          route: "/retailerProducts",
                          color: "info",
                          label: "view product",
                        }}
                        authors={[
                          { image: 'data:image/png;base64,' + myStorage[product["shop"]["logo_id"]],  name: product["shop"]["shop_name"] },
                        ]}
                        />
                      }
                    </Grid>
                ))}
            </Grid>
          </MDBox>
        </Card>
        <Footer />
    </DashboardLayout>
  );
}

export default RetailerProducts;
